import { useState } from 'react';
import OrgContext, { useCurrentOrgContext } from 'src/contexts/OrgContext';
import { Mode } from 'src/@types/mode';
import { useOrgSSEStatus } from '../hooks/query/orgHooks';

// 1. Provides context — no hooks that depend on context
export function OrgContextProvider({ children }: { children: React.ReactNode }) {
  const [orgId, setOrgId] = useState('');
  const [mode, setMode] = useState<Mode>((localStorage.getItem('lastMode') as Mode) || 'numinar');

  return (
    <OrgContext.Provider value={{ orgId, setOrgId, mode, setMode, sseStatus: undefined }}>
      {children}
    </OrgContext.Provider>
  );
}

// 2. Lives inside OrgContextProvider — patches in sseStatus once orgId is available
export function OrgSSEBridge({ children }: { children: React.ReactNode }) {
  const { orgId, setOrgId, mode, setMode } = useCurrentOrgContext();
  const { data: sseStatus } = useOrgSSEStatus();

  return (
    <OrgContext.Provider value={{ orgId, setOrgId, mode, setMode, sseStatus }}>
      {children}
    </OrgContext.Provider>
  );
}
